import React, { PureComponent } from 'react';

import DateBox from 'devextreme-react/date-box';
import RadioGroup from 'devextreme-react/radio-group';

import CoreUtils from '../utils/CoreUtils';
import TimeUtils from '../utils/TimeUtils';

import CutOffUtils from '../value-types/CutOffUtils';

const editorOptions = [{
  displayValue: 'WECC Trading Day',
  value: CutOffUtils.weccTradingDayPrefix
}, {
  displayValue: 'T-Minus (H:MM:SS)',
  value: CutOffUtils.hourEndingMinusPrefix
}];

export default class CutOffEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.onCutOffTypeListener = this.onCutOffTypeChanged.bind(this);
    this.onWeccCutOffTimeListener = this.onWeccCutOffTimeChanged.bind(this);
    this.onTMinusCutOffTimeListener = this.onTMinusCutOffTimeChanged.bind(this);
  }

  render() {
    this.updateCompositeValues();

    return (
      <table className="pwx-cutoff-editor"><tbody><tr>
        <td>
          <RadioGroup
            dataSource={editorOptions}
            disabled={this.props.disabled}
            displayExpr="displayValue"
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.onCutOffTypeListener}
            value={this.cutOffType}
            valueExpr="value"
            width={this.props.width}
          />
        </td>
        <td width="10" />
        <td>
          <DateBox
            disabled={this.props.disabled}
            displayFormat="h:mm aa"
            height="26"
            name={this.props.name}
            type="time"
            onValueChanged={this.onWeccCutOffTimeListener}
            value={TimeUtils.createPlaceholderTime(this.weccCutOffTime)}
            visible={this.cutOffType === CutOffUtils.weccTradingDayPrefix}
            width="105"
          />
          <DateBox
            disabled={this.props.disabled}
            displayFormat="H:mm:ss"
            height="26"
            invalidDateMessage="Value must be a time duration in the format of H:MM:SS."
            name={this.props.name}
            type="time"
            onValueChanged={this.onTMinusCutOffTimeListener}
            showDropDownButton={false}
            value={TimeUtils.createPlaceholderTime(this.tMinusCutOffTime)}
            visible={this.cutOffType === CutOffUtils.hourEndingMinusPrefix}
            width="90"
          />
        </td>
      </tr></tbody></table>
    );
  }

  updateCompositeValues() {
    this.cutOffType = CutOffUtils.parseType(this.props.value);

    if (this.cutOffType === CutOffUtils.hourEndingMinusPrefix) {
      this.tMinusCutOffTime = CutOffUtils.parseTime(this.props.value);
      this.weccCutOffTime = CutOffUtils.defaultWeccCutOffTime;
    } else {
      this.weccCutOffTime = CutOffUtils.parseTime(this.props.value);
      this.tMinusCutOffTime = CutOffUtils.defaultTMinusCutOffPeriod;
    }
  }

  onCutOffTypeChanged(event) {
    this.cutOffType = event.value;
    this.onControlValueChanged();
  }

  onWeccCutOffTimeChanged(event) {
    this.weccCutOffTime = TimeUtils.parseTimeFromDate(event.value);
    if (this.cutOffType !== CutOffUtils.weccTradingDayPrefix)
      return;

    this.onControlValueChanged();
  }

  onTMinusCutOffTimeChanged(event) {
    this.tMinusCutOffTime = TimeUtils.parseTimeFromDate(event.value);
    if (this.cutOffType !== CutOffUtils.hourEndingMinusPrefix)
      return;

    this.onControlValueChanged();
  }

  onControlValueChanged() {
    var value = CutOffUtils.combineTypes(
      this.cutOffType,
      this.cutOffType === CutOffUtils.hourEndingMinusPrefix
        ? this.tMinusCutOffTime
        : this.weccCutOffTime
    );

    if (CoreUtils.isDefinedAndNotNull(this.props.postEditFilter))
      value = this.props.postEditFilter(value);

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}